import {Component, forwardRef, OnInit,Input} from '@angular/core';
import { NG_VALUE_ACCESSOR, Validators, FormGroup, FormControl, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  compareMatch,
  PrimaryIndustrySelectionValue,
  GetIndustryDivisionsFn,
  IndustryDivision
} from '@portal-workspace/grow-shared-library';
import {distinctUntilChanged, tap} from 'rxjs/operators';
 
import {AbstractControlValueAccessor} from '../abstract-control-value-accessor';
import {UntilDestroy} from '@ngneat/until-destroy';
import {Subscription} from 'rxjs';
import {formControlErrorKeys, formControlErrorMessage, setupUntilDestroy} from '@portal-workspace/grow-ui-library';
import {MARK, Mark} from '@portal-workspace/grow-ui-library/mark';
import { MatOptionModule } from '@angular/material/core';

import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';


@UntilDestroy()
@Component({
    selector: 'primary-industry-selection',
    templateUrl: './primary-industry-selection.component.html',
    styleUrls: ['./primary-industry-selection.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => PrimaryIndustrySelectionComponent), multi: true },
        { provide: MARK, useExisting: forwardRef(() => PrimaryIndustrySelectionComponent) },
    ],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatOptionModule]
})
export class PrimaryIndustrySelectionComponent extends AbstractControlValueAccessor<PrimaryIndustrySelectionValue> implements OnInit, Mark {

  formGroup: FormGroup<{
    select: FormControl<PrimaryIndustrySelectionValue>;
  }>;
  formControl: FormControl<PrimaryIndustrySelectionValue>;

  primaryIndustries: IndustryDivision[] = [];
  subscription?: Subscription;
  errorKeys = formControlErrorKeys;
  errorMessage = formControlErrorMessage;

  @Input({ required: true }) getIndustryDivisionsFn: GetIndustryDivisionsFn | null = null;

  compareWithFn: (option: PrimaryIndustrySelectionValue, selected: PrimaryIndustrySelectionValue) => boolean = (option, selected) => {
    return (!!option && !!selected && option.code === selected.code);
  };

  constructor(private formBuilder: FormBuilder) {
    super();
    this.formControl = formBuilder.control(null, [Validators.required]);
    this.formGroup = formBuilder.group({
      select: this.formControl,
    });
    this.subscription = this.formControl.valueChanges.pipe(
      distinctUntilChanged(compareMatch),
      tap(r => {
        this.propagateChange(r);
      })
    ).subscribe();
  }

  ngOnInit(): void {
    setupUntilDestroy(this);
    this.getIndustryDivisionsFn?.().subscribe(r => {
      this.primaryIndustries = r;
    });
  }

  doWriteValue(v?: PrimaryIndustrySelectionValue): void | PrimaryIndustrySelectionValue {
    if (v) {
      const op = this.primaryIndustries.find(opt => opt.code === v.code);
      if (op) {
        this.formControl.setValue(op);
        return op;
      }else {
        this.formControl.setValue(v);
        return v;
      }
    } 
    return undefined;
  }
  mark() {
    this.formGroup.markAllAsTouched();
  }
}
